import api from './api';
import { Term, TermType, CreateTermRequest, UpdateTermRequest } from '../interfaces/Term';

export const termService = {
  async getAll(type?: TermType): Promise<Term[]> {
    const params = type ? { type } : {};
    const response = await api.get('/admin/terms', { params });
    return response.data;
  },

  async getById(id: string): Promise<Term> {
    const response = await api.get(`/admin/terms/${id}`);
    return response.data;
  },

  async create(data: CreateTermRequest): Promise<Term> {
    const response = await api.post('/admin/terms', data);
    return response.data;
  },

  async update(id: string, data: UpdateTermRequest): Promise<Term> {
    const response = await api.put(`/admin/terms/${id}`, data);
    return response.data;
  },

  async activate(id: string): Promise<Term> {
    const response = await api.patch(`/admin/terms/${id}/activate`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/terms/${id}`);
  },
};
